import { useMutation } from '@apollo/client';
import { CREATE_PROXY_OBJECT } from '../gql/mutations';

export const useCreateProxyObject = () => {
    const [ createProxyObjectMutation ] = useMutation( CREATE_PROXY_OBJECT );
    
    const createProxyObject = async ( { companyIntegrationId, fieldData } ) => {
        try {
            const variables = {
                'input': {
                    companyIntegrationId,
                    fieldData: {
                        ...fieldData
                    }
                }
            };
            
            const response = await createProxyObjectMutation( { variables } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success ) {
                return `${ response.data.result.id }`;
            } else {
                console.error( 'Error at createProxyObject' );
                return { error: true };
            } 
        } catch ( error ) { 
            console.error( 'Error at createProxyObject', error );
            return { error: true };
        }
    };

    return {
        createProxyObject
    };
};
